<template><other-stock-document-page direction="in" /></template>
<script>
import OtherStockDocumentPage from '../components/OtherStockDocumentPage'
export default { name: 'ErpOtherStockIn', components: { OtherStockDocumentPage } }
</script>
